import replace from 'lodash/replace';

export const replaceArrow = str => replace(str, new RegExp('->', 'g'), '→');
